<template>

  <v-card
    class="rounded-0 pa-7"
    elevation="0"
    style="height:100%"
  >
    <v-card-title class="titreBoite">{{$tc('accueil.BoitePrecision.Titre')}}</v-card-title>

    <div v-html="appStore.texteDynamique.BlocTexte5">
    </div>

    <v-btn
      class="rounded boutonPrincipal py-2"
      elevation="0"
      style="
        width: 100%;
        min-height: 48px;
        margin-top:20px;
        background-color: #095797;
        color: white !important;
      "
      href="pdf/RegleEtFonctionnementCoursEteEnLigne.pdf"
      target="_blank"
    >
      {{ $tc('accueil.BoitePrecision.boutonRegleEtFonctionnement') }}
    </v-btn>

    <div v-html="appStore.texteDynamique.BlocTexte6">
    </div>
    <!-- Procédure de connexion -->
    <v-btn
      class="rounded boutonPrincipal py-2"
      elevation="0"
      style="
        width: 100%;
        min-height: 48px;
        margin-top:20px;
        background-color: #095797;
        color: white !important;
      "
      href="pdf/GuideTechniqueEleve2023.pdf"
      target="_blank"
    >
      {{ $tc('accueil.BoitePrecision.ProcedureConnexionTeams') }}
    </v-btn>

    <div v-html="appStore.texteDynamique.BlocTexte7">
    </div>

  </v-card>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  name: 'BoitePrecisions',
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  computed: {

  },
};
</script>
